import React, {useEffect} from "react";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react"

import HomePage from "./pages/HomePage";
import ErrorPage from "./pages/ErrorPage";
import AppLayout from "./layouts/AppLayout";
import ProductsPage from "./pages/ProductsPage";
import EssencePage from "./pages/EssencePage";
import MomentsPage from "./pages/MomentsPage";
import WhereToBuyPage from "./pages/WhereToBuyPage";
import ScrollToTop from "./components/navigation/ScrollToTop";
import { trackEvent } from "./utils/analytics";

// Tracks how much traffic still lands on old bookmarked/shared URLs before
// bouncing them to the new tab-based /products route.
function TrackedRedirect({ from, to }) {
    useEffect(() => {
        trackEvent("legacy_redirect", { from_path: from, to_path: to });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Navigate to={to} replace />;
}

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                {/* Layout route */}
                <Route element={<AppLayout />}>
                    {/* Home only on "/" */}
                    <Route index element={<HomePage />} />

                    {/* Other pages */}
                    <Route path="products" element={<ProductsPage />} />
                    {/* Backward-compatible redirects */}
                    <Route path="bestsellers" element={<TrackedRedirect from="/bestsellers" to="/products?tab=bestsellers" />} />
                    <Route path="beans" element={<TrackedRedirect from="/beans" to="/products?tab=beans" />} />
                    <Route path="tamales" element={<TrackedRedirect from="/tamales" to="/products?tab=tamales" />} />
                    <Route path="rices" element={<TrackedRedirect from="/rices" to="/products?tab=rices" />} />
                    <Route path="essence" element={<EssencePage />} />
                    <Route path="moments" element={<MomentsPage />} />
                    <Route path="wheretobuy" element={<WhereToBuyPage />} />

                    {/* Error page */}
                    <Route path="*" element={<ErrorPage />} />
                </Route>
            </Routes>
            <Analytics />
        </BrowserRouter>
    );
}

export default App;
